import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CodeList } from '../add-training/codeList';
import { TrainingObj } from '../add-training/trainingObj';
import { AppService } from '../app.service';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ViewportScroller } from '@angular/common';
import { messageService } from '../message.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DynamicFlatNode } from '../my-tasks/my-tasks.component';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MsalService } from '@azure/msal-angular';
import { AssignTrainingComponent } from '../tms/assign-training/assign-training.component';

@Component({
  selector: 'app-manage-training',
  templateUrl: './manage-training.component.html',
  styleUrls: ['./manage-training.component.scss']
})
export class ManageTrainingComponent implements OnInit {

  dropDownForCategories: any = [];
  trainingList: TrainingObj[] = [];
  trainingsByCategories: any = {};
  trainingObj: TrainingObj = {};
  treeDataSource: any = [];
  showLeftNavForCategory = true;
  isProcessing = false;
  status = "";
  searchValue: any;
  isShowAddTrainingButton: any = false;
  categoriesListToCreateTraining: any = [];
  //@ViewChild('appDashboard', { static: false }) appDashboard: DashboardComponent;

  nameOfPage: any;
  tmsSettingsObj: any = {};
  userName: any;
  password: any = "";
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  dateCustomClasses: DatepickerDateCustomClasses[];
  isAdenabled: boolean = false;
  constructor(private appService: AppService, private router: Router, private scroller: ViewportScroller, public message: messageService,
    private route: ActivatedRoute, public dialog: MatDialog, private snackBar: MatSnackBar, private authService: MsalService) {
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y' ? true : false;

    this.route.params.subscribe(
      params => {
        let name = params['name'];
        this.nameOfPage = name;
        if (name == "Manage") {
          this.isProcessing = true;
          this.status = "In Progress";
          this.appService.getTrainingsList(this.status).subscribe((data: any) => {
            this.trainingList = data;
            console.log(" this.trainingList=", this.trainingList);
            this.isProcessing = false;
            this.appService.getCategoriesList().subscribe((data: any) => {
              this.dropDownForCategories = data;
              for (let i = 0; i < this.dropDownForCategories.length; i++) {
                const list = [];
                const key = this.dropDownForCategories[i].trainingCategoryCode;
                for (let j = 0; j < this.trainingList.length; j++) {
                  if (this.trainingList[j].categoryCode == this.dropDownForCategories[i].trainingCategoryCode) {
                    list.push(this.trainingList[j]);
                  }
                }
                this.trainingsByCategories[key] = list;
                this.treeDataSource.push({ 'name': this.dropDownForCategories[i].trainingCategoryName });
                if (this.dropDownForCategories[i].author == "Y") {
                  this.categoriesListToCreateTraining.push(this.dropDownForCategories[i]);
                  this.isShowAddTrainingButton = true;
                }
              }
            })
          })
        } else {
          this.userName = localStorage.getItem("loggedUserName");
          this.appService.getTmsSettingsVwDetails().subscribe((response: any) => {
            if (response != null) {
              this.tmsSettingsObj = response;
            } else {
              this.tmsSettingsObj = {};
            }
          });
          this.isProcessing = true;
          this.trainingsByCategories[name] = [];
          const data1 = {

            module: 'TRN',
            status: name
          };
          this.appService.getTaskDetail(data1)
            .subscribe((data: any) => {
              this.trainingList = data;
              this.isProcessing = false;
              this.trainingsByCategories[name] = this.trainingList;
            })
        }

      }
    );
  }

  ngOnInit(): void {
    const now = new Date();
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y' ? true : false;

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  getTraining(categoryCode: string) {
    return this.trainingsByCategories[categoryCode];
  }

  addTrainingFunc() {
    this.trainingObj.isFromDashboard = false;
    this.appService.setTrainingDetails(this.categoriesListToCreateTraining, this.trainingObj);
    this.message.breadcrumbData.thirdLevel = "Add Training";
    this.router.navigate(['/dashboard/addTraining']);
  }

  dueDate: any;
  title: any;
  trainingData: any = {};
  isShowDueDate: boolean = false;
  updateTrainingFunc(training: any) {
    if (this.nameOfPage == 'Manage') {
      this.trainingObj = training;
      this.trainingObj['isFromDashboard'] = false;
      this.isProcessing = true;
      this.changetypeAddAndEditPassword = true;
      this.appService.getTrainingByTrainingId(training.trainingId, training.version)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.appService.setTrainingDetails(this.dropDownForCategories, data[0]);
          this.message.breadcrumbData.thirdLevel = this.trainingObj.trainingName + "(" + this.trainingObj.trainingCode + ")";

          this.router.navigate(['/dashboard/addTraining']);
        })
    } else {
      if (training.status.includes("Locked")) {
        this.dueDate = null;
        this.title = training.status;
        this.isProcessing = true;

        this.appService.getUserTrainingsByTrainingId(training.taskNo).subscribe((data: any) => {
          this.trainingData = data[0];
          this.isProcessing = false;
          if (training.status == "Locked Overdue(RM Approved)" || training.status == "Locked Overdue") {
            this.isShowDueDate = true;
            this.isProcessing = true;
            this.appService.getGroupTrainingDetailsById(this.trainingData.groupId,
              this.trainingData.trainingId, this.trainingData.version).subscribe((data: any) => {
                this.isProcessing = false;
                if (data.length > 0 && data[0].dueNDayFromOverdueUnlock != null) {
                  this.dueDate = new Date();
                  this.dueDate.setDate(new Date().getDate() + data[0].dueNDayFromOverdueUnlock)
                }
              })
          } else {
            this.isShowDueDate = false;
          }
        })
        this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
      } else {
        this.trainingObj = training;
        this.trainingObj['isFromDashboard'] = false;
        this.isProcessing = true;
        this.appService.getAllCategoriesList().subscribe((data: any) => {
          this.dropDownForCategories = data;
          this.appService.getTrainingByTrainingId(training.taskNo, training.version)
            .subscribe((data: any) => {
              this.isProcessing = false;
              this.appService.setTrainingDetails(this.dropDownForCategories, data[0]);
              this.message.breadcrumbData.thirdLevel = this.message.breadcrumbData.thirdLevel = this.trainingObj.trainingName + "(" + this.trainingObj.trainingCode + ")";

              this.router.navigate(['/dashboard/addTraining']);
            })
        })
      }
    }
  }

  smoothScrollFun(id: any) {
    this.scroller.scrollToAnchor(id);

  }

  tabsList = ["In Progress", "Published", "Inactivated", "Obsoleted", "Expired"]

  selectedTab: any;
  selectedTabIndex: any;
  tabIndex: number = 0;
  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
    this.tabIndex = $event.index
    this.status = this.tabsList[this.tabIndex];
    this.trainingsByCategories = [];
    this.isProcessing = true;
    this.appService.getTrainingsList(this.status).subscribe((data: any) => {
      this.trainingList = data;
      console.log(" this.trainingList1=", this.trainingList);
      this.isProcessing = false;
      for (let i = 0; i < this.dropDownForCategories.length; i++) {
        const list = [];
        const key = this.dropDownForCategories[i].trainingCategoryCode;
        for (let j = 0; j < this.trainingList.length; j++) {
          if (this.trainingList[j].categoryCode == this.dropDownForCategories[i].trainingCategoryCode) {
            list.push(this.trainingList[j]);
          }
        }
        this.trainingsByCategories[key] = list;
      }
    })
  }

  backToPreviousPage() {
    history.back();
  }

  confirmWithFuncCall() {
    let data1 = {
      userTrainingId: this.trainingData.userTrainingId,
      dueDate: this.dueDate
    }
    this.isProcessing = true;
    this.appService.unlockTraining(data1).subscribe((data: any) => {
      this.isProcessing = false;
      if (data.resultType == "S") {
        this.visibleConfirmWithReason.close();
        this.isProcessing = true;
        this.trainingsByCategories[this.nameOfPage] = [];
        const data1 = {

          module: 'TRN',
          status: this.nameOfPage
        };
        this.appService.getTaskDetail(data1)
          .subscribe((data: any) => {
            this.trainingList = data;
            this.isProcessing = false;
            this.trainingsByCategories[this.nameOfPage] = this.trainingList;
          })
      } else {
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: data.result,
          type: data.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: data.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
    }, (error) => {

      this.isProcessing = false;
      throw error;
    })
  }
  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            // console.log("inside");

            this.confirmWithFuncCall();


          } else {
            // console.log("outside");
          }

        },
        error: (error) => {
          this.isProcessing = false;
        }
      });
  }

  confirmWithFunc() {
    if (this.tmsSettingsObj.esignatureAtTrainingUnlock == 'Y') {
      if (localStorage.getItem("adEnabled") == 'Y') {
        this.authEnable("adenabele")

      } else if (this.password == "") {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.confirmWithFuncCall();
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }
        })
      }
    } else {
      let data = {
        userTrainingId: this.trainingData.userTrainingId,
        dueDate: this.dueDate
      }
      this.isProcessing = true;
      this.appService.unlockTraining(data).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleConfirmWithReason.close();
          this.isProcessing = true;
          this.trainingsByCategories[this.nameOfPage] = [];
          const data1 = {

            module: 'TRN',
            status: this.nameOfPage
          };
          this.appService.getTaskDetail(data1)
            .subscribe((data: any) => {
              this.trainingList = data;
              this.isProcessing = false;
              this.trainingsByCategories[this.nameOfPage] = this.trainingList;
            })
        } else {
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, (error) => {

        this.isProcessing = false;
        throw error;
      })
    }
  }
  pass: any;
  passRequiredMsg: any;
  buttonOperationFieldValidation() {
    this.pass = document.getElementById('pass') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;
    if (this.password == "") {
      this.pass.style.border = '1px solid red';
      this.passRequiredMsg.style.display = 'block';
    } else {
      this.pass.style.border = 'none';
      this.passRequiredMsg.style.display = 'none';
    }
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  showAssignTraining = false;
  @ViewChild('training') assignTrainingComponent!: AssignTrainingComponent;
  assignTraining() {
    this.showAssignTraining = true;
    setTimeout(() => {
      this.assignTrainingComponent?.openAddPopup();
    });
  }

  onTrainingPopupClosed() {
    this.showAssignTraining = false;
  }

}
